/* CLYNT theme — shell behaviour.
   Progressive enhancement only: every link in here is reachable without JS. */

(function () {
  'use strict';

  var FOCUSABLE = 'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])';

  /* ------------------------------------------------------------------
     Shop mega-menu
     Opens on hover and on click/Enter, so it is operable by keyboard.
     Closes on mouse-leave, Escape and outside click.
     ------------------------------------------------------------------ */

  function initShopMenu(root) {
    var trigger = root.querySelector('[data-shop-trigger]');
    var panel = root.querySelector('[data-shop-panel]');
    if (!trigger || !panel) return;

    function open() {
      panel.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
    }

    function close() {
      panel.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
    }

    function isOpen() {
      return trigger.getAttribute('aria-expanded') === 'true';
    }

    root.addEventListener('mouseenter', open);
    root.addEventListener('mouseleave', close);

    trigger.addEventListener('click', function () {
      if (isOpen()) {
        close();
      } else {
        open();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && isOpen()) {
        close();
        trigger.focus();
      }
    });

    document.addEventListener('click', function (event) {
      if (isOpen() && !root.contains(event.target)) close();
    });

    root.addEventListener('focusout', function (event) {
      if (isOpen() && !root.contains(event.relatedTarget)) close();
    });
  }

  /* ------------------------------------------------------------------
     Mobile drawer
     Locks body scroll, traps focus, returns focus to the trigger.
     ------------------------------------------------------------------ */

  function initDrawer() {
    var drawer = document.querySelector('[data-drawer]');
    var opener = document.querySelector('[data-drawer-open]');
    var panel = drawer && drawer.querySelector('[data-drawer-panel]');
    if (!drawer || !opener || !panel) return;

    var lastFocused = null;

    function open() {
      lastFocused = document.activeElement;
      drawer.hidden = false;
      document.body.classList.add('is-drawer-open');
      opener.setAttribute('aria-expanded', 'true');

      var first = panel.querySelector(FOCUSABLE);
      if (first) first.focus();
    }

    function close() {
      drawer.hidden = true;
      document.body.classList.remove('is-drawer-open');
      opener.setAttribute('aria-expanded', 'false');
      if (lastFocused) lastFocused.focus();
    }

    function isOpen() {
      return !drawer.hidden;
    }

    opener.addEventListener('click', open);

    drawer.querySelectorAll('[data-drawer-close]').forEach(function (button) {
      button.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (event) {
      if (!isOpen()) return;

      if (event.key === 'Escape') {
        close();
        return;
      }

      if (event.key !== 'Tab') return;

      var items = Array.prototype.filter.call(
        panel.querySelectorAll(FOCUSABLE),
        function (el) { return el.offsetParent !== null; }
      );
      if (items.length === 0) return;

      var first = items[0];
      var last = items[items.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }


  /* ------------------------------------------------------------------
     Quantity steppers
     ------------------------------------------------------------------ */

  function initQty(root) {
    var input = root.querySelector('[data-qty-input]');
    var down = root.querySelector('[data-qty-down]');
    var up = root.querySelector('[data-qty-up]');
    if (!input || !down || !up) return;

    function step(delta) {
      var min = parseInt(input.getAttribute('min'), 10) || 0;
      var next = (parseInt(input.value, 10) || 0) + delta;
      if (next < min) next = min;
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    down.addEventListener('click', function () { step(-1); });
    up.addEventListener('click', function () { step(1); });
  }

  /* ------------------------------------------------------------------
     Product gallery
     ------------------------------------------------------------------ */

  function initGallery(root) {
    var thumbs = root.querySelectorAll('[data-gallery-thumb]');
    var slides = root.querySelectorAll('[data-gallery-slide]');
    if (thumbs.length === 0) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = thumb.getAttribute('data-gallery-thumb');

        slides.forEach(function (slide) {
          slide.classList.toggle('is-active', slide.getAttribute('data-gallery-slide') === index);
        });

        thumbs.forEach(function (other) {
          other.setAttribute('aria-pressed', other === thumb ? 'true' : 'false');
        });
      });
    });
  }

  /* ------------------------------------------------------------------
     Variant selection and add to cart
     ------------------------------------------------------------------ */

  function money(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style: 'currency',
        currency: currency
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function strings(key, fallback) {
    return (window.CLYNT_STRINGS && window.CLYNT_STRINGS[key]) || fallback;
  }

  function initProduct(root) {
    var data = document.querySelector('[data-product-variants]');
    var select = root.querySelector('[data-variant-select]');
    var form = root.querySelector('form[action*="/cart/add"]');
    if (!data || !select || !form) return;

    var variants;
    try {
      variants = JSON.parse(data.textContent);
    } catch (e) {
      return;
    }

    var radios = root.querySelectorAll('[data-option-position]');
    var priceEl = root.querySelector('[data-price]');
    var noteEl = root.querySelector('[data-variant-note]');
    var button = root.querySelector('[data-atc]');
    var labelEl = root.querySelector('[data-atc-label]');
    var totalEl = root.querySelector('[data-atc-total]');
    var qtyInput = root.querySelector('[data-qty-input]');
    var status = document.querySelector('[data-atc-status]');

    function currentVariant() {
      if (radios.length === 0) {
        return variants.filter(function (v) { return String(v.id) === String(select.value); })[0];
      }

      var chosen = [];
      radios.forEach(function (radio) {
        if (radio.checked) {
          chosen[parseInt(radio.getAttribute('data-option-position'), 10) - 1] = radio.value;
        }
      });

      return variants.filter(function (v) {
        return chosen.every(function (value, i) { return v.options[i] === value; });
      })[0];
    }

    function refresh() {
      var variant = currentVariant();
      if (!variant) return;

      select.value = variant.id;

      if (priceEl) priceEl.textContent = money(variant.price);
      if (noteEl) noteEl.textContent = variant.title === 'Default Title' ? '' : variant.title;

      if (button) {
        button.disabled = !variant.available;
        if (labelEl) {
          labelEl.textContent = variant.available
            ? strings('addToCart', 'Add to cart')
            : strings('soldOut', 'Sold out');
        }
        if (totalEl) {
          var qty = (qtyInput && parseInt(qtyInput.value, 10)) || 1;
          totalEl.textContent = variant.available ? money(variant.price * qty) : '';
        }
      }

      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {
        /* history is a convenience, never a requirement */
      }
    }

    radios.forEach(function (radio) { radio.addEventListener('change', refresh); });
    select.addEventListener('change', refresh);
    if (qtyInput) qtyInput.addEventListener('change', refresh);

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var body = new FormData(form);
      if (status) status.textContent = '';
      if (button) button.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: body
      })
        .then(function (response) {
          if (!response.ok) throw new Error('add failed');
          return response.json();
        })
        .then(function () {
          return fetch('/cart.js', { headers: { Accept: 'application/json' } });
        })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-link]').forEach(function (link) {
            var base = link.textContent.split('(')[0].split('\u00b7')[0].trim();
            link.textContent = cart.item_count > 0 ? base + ' (' + cart.item_count + ')' : base;
          });

          if (status) {
            status.innerHTML = '';
            var text = document.createElement('span');
            text.textContent = strings('added', 'Added to your cart.');
            var link = document.createElement('a');
            link.href = '/cart';
            link.textContent = strings('viewCart', 'View cart');
            status.appendChild(text);
            status.appendChild(link);
          }
        })
        .catch(function () {
          if (status) status.textContent = strings('addError', 'Could not add that to your cart.');
        })
        .then(function () {
          if (button) button.disabled = false;
          refresh();
        });
    });

    refresh();
  }

  /* ------------------------------------------------------------------
     Product recommendations
     ------------------------------------------------------------------ */

  function initRecommendations(root) {
    var url = root.getAttribute('data-url');
    if (!url) return;

    fetch(url)
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) root.innerHTML = fresh.innerHTML;
      })
      .catch(function () { /* recommendations are non-essential */ });
  }


  /* ------------------------------------------------------------------
     Cart — quantity and removal via section rendering, never a reload
     ------------------------------------------------------------------ */

  function initCart(root) {
    var sectionId = root.getAttribute('data-cart-section');

    function render(line, quantity) {
      root.setAttribute('aria-busy', 'true');

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          line: line,
          quantity: quantity,
          sections: sectionId,
          sections_url: window.location.pathname
        })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('cart change failed');
          return response.json();
        })
        .then(function (cart) {
          var markup = cart.sections && cart.sections[sectionId];
          if (markup) {
            var parsed = new DOMParser().parseFromString(markup, 'text/html');
            var fresh = parsed.querySelector('[data-cart-section]');
            if (fresh) {
              root.innerHTML = fresh.innerHTML;
              root.querySelectorAll('[data-qty]').forEach(initQty);
            }
          }

          document.querySelectorAll('[data-cart-link]').forEach(function (link) {
            var base = link.textContent.split('(')[0].split('\u00b7')[0].trim();
            link.textContent = cart.item_count > 0 ? base + ' (' + cart.item_count + ')' : base;
          });
        })
        .catch(function () {
          window.location.reload();
        })
        .then(function () {
          root.removeAttribute('aria-busy');
        });
    }

    root.addEventListener('change', function (event) {
      var input = event.target.closest('[data-qty-input]');
      if (!input) return;

      var group = input.closest('[data-line]');
      if (!group) return;

      render(parseInt(group.getAttribute('data-line'), 10), parseInt(input.value, 10) || 0);
    });

    root.addEventListener('click', function (event) {
      var remove = event.target.closest('[data-cart-remove]');
      if (!remove) return;

      event.preventDefault();
      render(parseInt(remove.getAttribute('data-cart-remove'), 10), 0);
    });
  }

  function init() {
    document.querySelectorAll('[data-shop-menu]').forEach(initShopMenu);
    initDrawer();
    document.querySelectorAll('[data-qty]').forEach(initQty);
    document.querySelectorAll('[data-product-root]').forEach(function (root) {
      initGallery(root);
      initProduct(root);
    });
    document.querySelectorAll('[data-recommendations]').forEach(initRecommendations);
    document.querySelectorAll('[data-cart-section]').forEach(initCart);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
